// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.talkChatTab[data-v-5d8bc5b4] {\n\theight: 100%;\n\n\tdisplay: flex;\n\tflex-grow: 1;\n\tflex-direction: column;\n}\n.call-button[data-v-5d8bc5b4] {\n\t/* Center button horizontally. */\n\tmargin-left: auto;\n\tmargin-right: auto;\n\n\tmargin-top: 10px;\n\tmargin-bottom: 10px;\n}\n.chatView[data-v-5d8bc5b4] {\n\toverflow: hidden;\n}\n", ""]);
// Exports
module.exports = exports;
